"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _vueAdvancedCropper = require("vue-advanced-cropper");

require("vue-advanced-cropper/dist/style.css");

var _functions = require("../../utilities/functions");

var DEFAULT_OPTIONS = {
  aspectRatio: 1,
  maxWidth: null,
  maxHeight: null,
  maxFileSizeMb: 5
};

exports.default = {
  /**
   * Name
   */
  name: "ImageUpload",

  /**
   * Props
   */
  props: {
    /**
     * Save image url
     */
    url: {
      type: String,
      required: true
    },

    /**
     * Cropper options
     */
    options: {
      type: Object,
      default: function _default() {
        return _extends({}, DEFAULT_OPTIONS);
      }
    }
  },

  /**
   * Data
   * @returns {{image: {scr: string}}}
   */
  data: function data() {
    return {
      file: null,
      defaultOptions: _extends({}, DEFAULT_OPTIONS)
    };
  },


  /**
   * Components
   */
  components: {
    Cropper: _vueAdvancedCropper.Cropper
  },

  /**
   * Computed
   */
  computed: {
    /**
     * Preview image
     * @returns {{src: (string|string), type: (*|string)}}
     */
    image: function image() {
      return {
        src: this.file ? URL.createObjectURL(this.file) : "",
        type: this.file ? this.file.type : ""
      };
    },


    /**
     * Cropp options
     * @returns {{}}
     */
    croppOptions: function croppOptions() {
      return _extends({}, this.defaultOptions, this.options || {});
    }
  },

  /**
   * Methods
   */
  methods: {
    /**
     * Save image
     */
    save: function save() {
      this.send();
    },


    /**
     * Send image to server
     */
    send: function send() {
      var _this = this;

      var _$refs$cropper$getRes = this.$refs.cropper.getResult(),
          canvas = _$refs$cropper$getRes.canvas;

      if (canvas) {
        var form = new FormData();
        canvas.toBlob(function (blob) {
          form.append("files", blob);
          axios.post(_this.url, form).then(function (_ref) {
            var data = _ref.data;

            _this.$emit("imageuploaded", data);
            _this.cancel();
          });
        }, "image/jpeg");
      }
    },


    /**
     * Cancel image uploading
     * @param event
     */
    cancel: function cancel(event) {
      URL.revokeObjectURL(this.image.src);
      this.file = null;
    },


    /**
     * Image changed
     * @param event
     */
    changeImage: function changeImage(event) {
      var files = event.target.files;


      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }

        try {
          this.validate(files[0]);
        } catch (e) {
          return this.$toastr.error(e);
        }

        this.file = files[0];

        /**
         * Reset input file value to be able
         * to edit the same file twice
         * @type {null}
         */
        event.target.value = null;
      }
    },


    /**
     * Open file system modal window
     * @param event
     */
    clickImageUpload: function clickImageUpload(event) {
      this.$refs.file.click();
    },


    /**
     * Validate image preview loading
     * @param file
     * @returns {boolean}
     */
    validate: function validate(file) {
      var fileSizeMb = (0, _functions.filesize)(file.size).mb();

      if (fileSizeMb > this.croppOptions.maxFileSizeMb) {
        throw Error(this.$t("common.messages.large_image_size_error", {
          size: this.croppOptions.maxFileSizeMb
        }));
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/elements/ImageUpload.vue
// module id = yay4
// module chunks = 0 1